import { CONTACTS, SERVICES } from "../data";
import { useLang, STR } from "../i18n";

export const Footer = () => {
  const { lang } = useLang();
  const t = STR[lang];
  const NAV = [
    { label: t.nav.home, href: "#top" },
    { label: t.nav.studio, href: "#studio" },
    { label: t.nav.servizi, href: "#servizi" },
    { label: t.nav.progetti, href: "#progetti" },
    { label: t.nav.gallery, href: "#gallery" },
    { label: t.nav.contatti, href: "#contatti" },
  ];

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#09203a] text-white pt-[48px] pb-[22px]" data-testid="footer">
      <div className="max-w-[1320px] mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-[1.45fr_1fr_1fr_1.35fr] gap-[50px]">
          <div>
            <img
              src="/assets/logo-footer.png"
              alt="PROJECT WORKS — Studio Tecnico Associato"
              className="w-[290px]"
              data-testid="footer-logo"
            />
          </div>
          <div>
            <h4 className="text-[10px] tracking-[0.12em] uppercase mb-[18px]">{t.footer.quickLinks}</h4>
            <ul data-testid="footer-nav">
              {NAV.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={(e) => go(e, l.href)} className="text-[11px] text-[#bdc8d0] leading-[1.8] hover:text-[#F18A00] transition-colors" data-testid={`footer-link-${l.href.slice(1)}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-[10px] tracking-[0.12em] uppercase mb-[18px]">{t.footer.services}</h4>
            <ul data-testid="footer-services">
              {t.services.items.map((s) => (
                <li key={s.title} className="text-[11px] text-[#bdc8d0] leading-[1.8]">{s.title}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-[10px] tracking-[0.12em] uppercase mb-[18px]">{t.footer.contacts}</h4>
            <ul data-testid="footer-details">
              <li className="text-[11px] text-[#bdc8d0] leading-[1.8]">{CONTACTS.address}</li>
              <li className="text-[11px] leading-[1.8]">
                <a href={`tel:${CONTACTS.phone1.replace(/\s/g, "")}`} className="text-[#bdc8d0] hover:text-[#F18A00] transition-colors">{CONTACTS.phone1}</a>
              </li>
              <li className="text-[11px] leading-[1.8]">
                <a href={`tel:${CONTACTS.phone2.replace(/\s/g, "")}`} className="text-[#bdc8d0] hover:text-[#F18A00] transition-colors">{CONTACTS.phone2}</a>
              </li>
              <li className="text-[11px] leading-[1.8]">
                <a href={`mailto:${CONTACTS.email}`} className="text-[#bdc8d0] hover:text-[#F18A00] transition-colors" data-testid="footer-email">{CONTACTS.email}</a>
              </li>
              <li className="text-[11px] text-[#9eacb7] leading-[1.8]" data-testid="footer-vat">{CONTACTS.vat}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/[0.18] mt-[38px] pt-[18px] flex flex-col md:flex-row justify-between gap-2 text-[10px] text-[#9eacb7]">
          <span>© {new Date().getFullYear()} Project Works Studio Tecnico Associato · {t.footer.rights}</span>
          <span>
            <a href={lang === "en" ? "/en/privacy-policy/" : "/privacy-policy/"} className="hover:text-[#F18A00] transition-colors" data-testid="footer-privacy-link">Privacy Policy</a>
            &nbsp; | &nbsp;
            <a href={lang === "en" ? "/en/cookie-policy/" : "/cookie-policy/"} className="hover:text-[#F18A00] transition-colors" data-testid="footer-cookie-link">Cookie Policy</a>
          </span>
        </div>
      </div>
    </footer>
  );
};
